import LangEnum from '../../../../../lang/LangEnum';
import { CatalogSectionSortCriterionEnum } from '../../../enums/catalogSectionSortCriterion.enum';
import { SECTION_SORT_CRITERION_LANG } from '../../../sectionSortCriterion.const';
import { DEFAULT_CATALOG_CARD_SIZE_KEY } from '../sizing/catalogCardSize.consts';
import {
  CatalogViewCatalogField,
  CatalogViewCatalogFields,
  CatalogViewGroupBy,
  CatalogViewMode,
  CatalogViewOption,
  CatalogViewUserField,
} from './catalogView.types';

export const DEFAULT_CATALOG_VIEW: CatalogViewCatalogFields = {
  mode: CatalogViewMode.CARD,
  cardSize: DEFAULT_CATALOG_CARD_SIZE_KEY,
  groupBy: CatalogViewGroupBy.MANUAL,
  groupTargetId: null,
  sortCriterion: CatalogSectionSortCriterionEnum.MANUAL,
  sortTargetId: null,
};

/**
 * Keyed, not listed: `CatalogViewCatalogField[]` accepts a short array, so a new catalog-level
 * field missing from it compiles and then never shows up in `dirtyForAll` — never sent, silently.
 */
const CATALOG_VIEW_CATALOG_FIELD_KEYS: Record<CatalogViewCatalogField, true> = {
  mode: true,
  cardSize: true,
  groupBy: true,
  groupTargetId: true,
  sortCriterion: true,
  sortTargetId: true,
};

export const CATALOG_VIEW_CATALOG_FIELDS = Object.keys(
  CATALOG_VIEW_CATALOG_FIELD_KEYS,
) as CatalogViewCatalogField[];

export const CATALOG_VIEW_USER_FIELDS: CatalogViewUserField[] = CATALOG_VIEW_CATALOG_FIELDS;

/**
 * RF1.9 — the five from the enum, which is where "exactly five" is enforced: "no grouping" is a
 * Figma mistake and has no member to hang on. Labels reuse existing keys: creating
 * CATALOGS_VIEW_GROUP_BY_* with the same copy would duplicate a pt-BR.ts value and break CA1.25.
 *
 * Keyed, so the destructive confirmation can name the criterion by value (RF5.2b) without a
 * lookup that can miss — and a new member of the enum fails the build here.
 */
export const CATALOG_VIEW_GROUP_BY_LANG: Record<CatalogViewGroupBy, LangEnum> = {
  [CatalogViewGroupBy.MANUAL]: LangEnum.CATALOGS_VIEW_GROUP_BY_MANUAL,
  [CatalogViewGroupBy.COLLECTION]: LangEnum.GLOBAL_COLLECTION,
  [CatalogViewGroupBy.CATEGORY]: LangEnum.GLOBAL_CATEGORY,
  [CatalogViewGroupBy.SUBCATEGORY]: LangEnum.GLOBAL_SUBCATEGORY,
  [CatalogViewGroupBy.CLASSIFICATION_TYPE]:
    LangEnum.CATALOGS_CATALOG_SECTION_SORT_CRITERION_CLASSIFICATION,
};

export const CATALOG_VIEW_GROUP_BY_OPTIONS: CatalogViewOption<CatalogViewGroupBy>[] = Object.values(
  CatalogViewGroupBy,
).map((value) => ({
  value,
  label: CATALOG_VIEW_GROUP_BY_LANG[value],
}));

export const CATALOG_VIEW_SORT_OPTIONS: CatalogViewOption<CatalogSectionSortCriterionEnum>[] =
  Object.values(CatalogSectionSortCriterionEnum).map((value) => ({
    value,
    label: SECTION_SORT_CRITERION_LANG[value],
  }));
